import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=c83f9a9a&scoped=true"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupModal.vue?vue&type=style&index=0&id=c83f9a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83f9a9a",
  null
  
)

export default component.exports